var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40092 1.89356L17.7592 4.88857L21.7743 3.67348L12.5004 1L9.4019 1.89373L9.40092 1.89356ZM18.2336 5.7614L18.2355 10.1482C18.2355 10.4172 18.0178 10.635 17.7487 10.635C17.4796 10.635 17.2619 10.4172 17.2619 10.1482V6.05518L12.9864 7.34918V21.0756L23 18.1882V4.31839L18.2338 5.76072L18.2336 5.7614ZM16.2018 5.36018L7.80942 2.353L3.22672 3.67458L12.5007 6.48022L16.2018 5.36018ZM12.0136 21.0754V7.34898L2 4.31892V18.1887L12.0136 21.0761V21.0754Z",
    fill: "#FE5F55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.5a38f8ac602f8685ba4e70d93434c584.svg";
export { ForwardRef as ReactComponent };